import React from 'react';
import CustomerCard from './CustomerCard';
import InfoCard from './InfoCard';
import VehicleCard from './VehicleCard';

const Details = ({ externalOrderNumber, totalAmount, baseAmount, updatedBaseAmount, createdAt, status, seller, establishment, terminal, customer }) => (
    <div className="row">
        <div className={`${(customer) ? 'col-12' : 'col'}`}>
            <InfoCard
                updatedBaseAmount={updatedBaseAmount}
                externalOrderNumber={externalOrderNumber}
                baseAmount={baseAmount}
                totalAmount={totalAmount}
                createdAt={createdAt}
                seller={seller}
                establishment={establishment}
                status={status}
                terminal={terminal}
            />
        </div>
        {customer &&
            <div className="col-6">
                <CustomerCard {...customer} />
            </div>
        }
        {customer && customer.licensePlate &&
            <div className="col-6">
                <VehicleCard {...customer} />
            </div>
        }
    </div>
);

export default Details;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Details/index.js